<template>
  <div class="">
    <div class="navbar-container d-flex content align-items-center">
      <!-- Nav Menu Toggler -->
      <ul class="nav navbar-nav">
        <li class="nav-item">
          <b-link
            class="nav-link d-xl-none"
            @click="toggleVerticalMenuActive"
          >
            <feather-icon
              icon="MenuIcon"
              size="21"
            />
          </b-link>
        </li>
        <!--        <li class="nav-item ">-->
        <!--          &lt;!&ndash; App logo for mobile view &ndash;&gt;-->
        <!--          <turtle-rent-logo width="150" />-->
        <!--        </li>-->

        <li class="nav-item d-none d-sm-block">
          <div v-if="isPharmacyAccount">
            <h5>{{ pharmacyProfile.pharmacy_name }}</h5>
          </div>

          <div v-if="isLabAccount">
            <h5>{{ labProfile.lab_name }}</h5>
          </div>

          <!-- make this a shared component which will be from the route meta -->
          <div class="d-flex align-items-center">
            <h3 class="text-muted lead">
              {{ getValueFromSource($route, 'meta.pageTitle', '') }}</h3>
          </div>
        </li>
      </ul>

      <!-- Left Col -->
      <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
        <!-- Bookmarks Container -->
        <!-- <bookmarks /> -->
      </div>

      <b-navbar-nav class="nav align-items-center ml-auto">
        <p class="text-primary m-0 mr-2 d-none d-lg-flex">
          Hello, {{ currentUser.full_name }}
        </p>
        <!-- <locale /> -->
        <dark-toggler />
        <notification-dropdown />
        <user-dropdown />
      </b-navbar-nav>
    </div>

    <app-breadcrumb v-if="(y === 0) || (y > 0 && y <= 27)" />
  </div>
</template>

<script>
import {
  BLink, BAvatar, BNavbarNav,
} from 'bootstrap-vue'
import { useWindowScroll } from '@vueuse/core'

import TurtleRentLogo from '@core/layouts/components/Logo.vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'


import Locale from './components/Locale.vue'
import DarkToggler from './components/DarkToggler.vue'
import UserDropdown from './components/UserDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'


export default {
  components: {
    TurtleRentLogo,
    BLink,
    BAvatar,
    AppBreadcrumb,

    // Navbar Components
    BNavbarNav,
    Locale,
    DarkToggler,
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const { y } = useWindowScroll()
    return { y }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/swiper.scss';
</style>
